import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function useCustomFields(entity) {
  const [fields, setFields] = useState([]);
  useEffect(() => {
    let mounted = true;
    api.get("/custom-fields", { params: { entity } })
      .then((r) => mounted && setFields(r.data))
      .catch(() => {});
    return () => { mounted = false; };
  }, [entity]);
  return fields;
}

export default function DynamicFields({ entity, values = {}, onChange, title = "Additional Details" }) {
  const fields = useCustomFields(entity);
  if (!fields.length) return null;

  return (
    <div className="mt-4 pt-4 border-t" data-testid={`dynamic-fields-${entity}`}>
      <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-3">{title}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {fields.map((f) => {
          const v = values[f.field_key] ?? "";
          const set = (val) => onChange(f.field_key, val);
          return (
            <div key={f.id} className="space-y-1.5" data-testid={`custom-field-${f.field_key}`}>
              <Label className="text-sm">{f.label}{f.required && <span className="text-red-500 ml-0.5">*</span>}</Label>
              {f.field_type === "textarea" ? (
                <Textarea value={v} onChange={(e) => set(e.target.value)} />
              ) : f.field_type === "dropdown" ? (
                <Select value={v} onValueChange={set}>
                  <SelectTrigger data-testid={`custom-input-${f.field_key}`}><SelectValue placeholder="Select" /></SelectTrigger>
                  <SelectContent>{(f.options || []).map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
                </Select>
              ) : (
                <Input
                  data-testid={`custom-input-${f.field_key}`}
                  type={f.field_type === "number" ? "number" : f.field_type === "date" ? "date" : "text"}
                  value={v}
                  onChange={(e) => set(e.target.value)}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
